import type { RouteObject } from "react-router-dom";
import { PagesLeadManagerUiDisplay } from "./Display";

export const PagesLeadManagerUiRoutes: RouteObject[] = [
  {
    path: "leadManager",
    children: [
      { element: <PagesLeadManagerUiDisplay />, index: true },
      { element: <PagesLeadManagerUiDisplay />, path: ":section" }
    ]
  }
];
